import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Captures from "../../assets/images/login/logo.png";
import { useSiteContext } from "../../contexts/SiteProvider";
import { post } from "../../services/smartApiService";
//import back from '../../assets/images/background.avif';
import { SmartFormInterFace, SmartSoftForm } from "soft_digi";
import { showNotification } from "../../services/notifyService";
import "./Login.scss";

const Login = () => {
  const { setLoading, setUser, startSessionAct } = useSiteContext();
  const navigate = useNavigate();
  const [formData, setFormData] = useState<any>({}); 
  const [error, setError] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const handleLogin = () => {
    const subscription = post("auth/login", formData, {requiresAuthorization:false,loadingMsg:"Logging in... Please wait"}).subscribe((response) => {
      setUser(response.data.data);
      setLoading(false);
     // startSessionAct();
      navigate("/auth/dashboard")
      showNotification("success", "Logged in Successfully")
    }
    );
    return () => {
      subscription.unsubscribe();
    };
  };

  const handleRememberMe = (remember:any) => {
    if (remember) {
      localStorage.setItem("rememberedEmail", formData?.euserid);
      localStorage.setItem("rememberedPassword", formData?.epassword);
    } else {
      localStorage.removeItem("rememberedEmail");
      localStorage.removeItem("rememberedPassword");
    }
  };

  useEffect(() => {
    const rememberedEmail = localStorage.getItem("rememberedEmail");
    const rememberedPassword = localStorage.getItem("rememberedPassword");
    if (rememberedEmail || rememberedPassword) {     
      setFormData((prev:any) => ({ ...prev, euserid: rememberedEmail, epassword: rememberedPassword }));
      setRememberMe(true);
    }
  }, []);





  const handleInputChange = (name:string, value:any) => {
    setFormData((prev:any) => ({ ...prev, [name]: value }));
  };

  const validations = {
    emailValidation: {
      type: "email",
      msg: "Please enter the valid email",
      emailPattern: "/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$/",
    },
    passwordValidation: [
      {
        type: "required",
        msg: "Numeric Value is Required",
      },
      {
        type: "password",
        minLength: "6",
        msg: "minmum 6 character are required",
      },
    ],
  };

  const pwlabel = () => {
    return (
      <div className="pw_label">
        <span>Password</span>
        {/* <Link to="/forget" className="signup-link has-text-weight-normal">
          <span onClick={handleForgetPassword}>forgot password?</span>
        </Link> */}
      </div>
    );
  };

  const elements:SmartFormInterFace.SmartFormElementProps[] = [
    {
      type: "TEXT_BOX",
      width: "12",
      name: "euserid",
      element: {
        classList: ["smart-form-input"],
        label: "Employee ID",
        placeHolder: "You@example.com",
        validations: validations.emailValidation,
      },
    },
    {
      type: "PASSWORD",
      width: "12",
      name: "epassword",
      element: {
        classList: ["smart-form-input"],
        label: pwlabel(),
        placeHolder: "Enter 6 Characters or more",
        validations: validations.passwordValidation,
        // pattern:VALID_PASSWORD_GENERAL
      },
    },
    {
      type: "BUTTON",
      width: "12",
      name:"button",
      class_name: "has-text-right",
      element: {
        label: "LOGIN",
        classList: ["button login-btn has-text-weight-bold has-text-white is-fullwidth"],
        onClick: handleLogin,
      },
    },
  ];

  return (
    <div className="login-container flex-center m-0 p-0">
      <div className="columns login-grp-box p-2 has-background-white">
        <div className="column login-fields p-4">
          <header className="is-flex is-justify-content-space-between is-align-items-center">
            <h1 className="login-title">Login</h1>
            <span className="icon smart-cursor" onClick={() => navigate("/home")}>
              <i className="fa fa-arrow-left"></i>
            </span>
          </header>
          <SmartSoftForm
            formData={formData}
            setFormData={handleInputChange}
            elements={elements}
          />
          {error && <p className="login-help">{error}</p>}

          <div className="text-label">
            <label>
              <input
                className="mr-2"
                type="checkbox"
                checked={rememberMe}
                onChange={(e) => {
                  setRememberMe(e.target.checked);
                  handleRememberMe(e.target.checked);
                }}
              />
              Remember Me
            </label>
          </div>
        </div>

        <div className="column">
          <figure className="login-img has-text-centered">
            <img src={Captures} alt="captures" />
          </figure>
        </div>
      </div>
    </div>
  );
};

export default Login;
